<script lang="ts">
	import { onMount } from 'svelte';
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<SVGElement> {
		videoElement: HTMLVideoElement;
	}

	let { videoElement, ...other }: Props = $props();

	function getProgress(): number {
		if (!videoElement?.duration || Number.isNaN(videoElement.duration)) return 0;

		return (videoElement.currentTime / videoElement.duration) * 100;
	}

	let videoProgress = $state(getProgress());

	onMount(() => {
		function updateProgress() {
			videoProgress = getProgress();
		}

		videoElement.addEventListener('timeupdate', updateProgress);

		return () => {
			videoElement.removeEventListener('timeupdate', updateProgress);
		};
	});
</script>

<svg viewBox="0 0 120 120" {...other}>
	<circle
		class={['progress', { animate: videoProgress >= 1 }]}
		style="--progress: {videoProgress}"
		cx="60"
		cy="60"
		r="57"
		fill="none"
		stroke="currentColor"
		stroke-width="6"
		pathLength="100"
	/>
</svg>

<style lang="scss">
	svg {
		transform: rotate(-90deg);
	}

	.progress {
		stroke-dasharray: 100;
		stroke-dashoffset: calc(100 - var(--progress));

		&.animate {
			transition: stroke-dashoffset 0.32s linear;
		}
	}
</style>
